import { atom, useAtomValue } from 'jotai';
import { useCallback } from 'react';

export const permissionAtom = atom<string[] | null>(null);

export const useCheckPermission = () => {
  const value = useAtomValue(permissionAtom);

  return useCallback(
    (str: string) => {
      const set = new Set(value);
      return set.has(str);
    },
    [value]
  );
};
